import { t } from '@lingui/core/macro';
import { SupplierDTO } from '@luminovo/api-contracts';
import { isPresent } from '@luminovo/commons';
import { FieldMultiSelect, FieldMultiSelectProps } from '@luminovo/design-system';
import type { JSX } from 'react';

export interface FieldSuppliersProps<T extends SupplierDTO = SupplierDTO> extends Omit<
    FieldMultiSelectProps<T>,
    'getOptionLabel' | 'getOptionKey'
> {
    getOptionLabel?: (supplier: T) => string;
}

export function FieldSuppliers<T extends SupplierDTO = SupplierDTO>({ ...props }: FieldSuppliersProps<T>): JSX.Element {
    return (
        <FieldMultiSelect
            size="medium"
            virtualized
            getOptionKey={(s) => s.id}
            getOptionLabel={(supplier) => (isPresent(supplier) ? `${supplier.name}` : t`No recipient selected`)}
            isOptionEqualToValue={(opt, value) => opt.id === value.id}
            disableClearable
            {...props}
        />
    );
}
